
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAABvUExURQAAADh7/zl5/zh6/zl6/zh6/zh3/0Bw/zl6/zd5 /zl5/zh3/zl7/zd5/zl7/0B//zh5/zl5/zh6/3aj/5u8/4Or/6jF/////6fF//L3/1GK/1GL/7TN /9rm/4Ks/+bv/+bu/460/0WC/4Kr/wAAAHKyJyIAAAASdFJOUwBAj9/PnyAQkI/PQM/PjxDfP5Lb pTEAAAABYktHRACIBR1IAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5wwEAzkiVKWJywAA AKVJREFUKM+1koEOgiAQhi8U0KyssyJUNO393zEo0NU4t9z6xga7b3e7jR/AsmEJfpByAW9khhFy +XIpRtk6myFBDiCQpABOSwa78KzOnkuoJBBeVzVxC7VJzk7pJal+lrW7G0K2btd25diKlHasWbft X6TuemWMug96liFaXY3jMNqDzcOX9nCgP5tDQUsbT7KV2fSVS9GEMtrLpM+84F/dR3Zy9SeNhzcY k7uJWAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMy0xMi0wNFQwMjozMjowOSswMDowMJjV/CYAAAAl dEVYdGRhdGU6bW9kaWZ5ADIwMjMtMTItMDRUMDI6MzI6MTArMDA6MDCwugHXAAAAKHRFWHRkYXRl OnRpbWVzdGFtcAAyMDIzLTEyLTA0VDAzOjU3OjM0KzAwOjAwgs/b5AAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    